<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_5"></a>
<p class="contents">CONTENTS</p>
<p class="toc2"><a href="#/07_Part_01" id="pt1">EASTERN APPROACHES</a></p>
<p class="toc1"><a href="#/08_Chapter_01" id="ch1">Kindly Stranger</a></p>
<p class="toc1"><a href="#/09_Chapter_02" id="ch2">Give Us This Day</a></p>
<p class="toc1"><a href="#/10_Chapter_03" id="ch3">Dionysus and the Pard</a></p>
<p class="toc1"><a href="#/11_Chapter_04" id="ch4">Low Water</a></p>
<p class="toc2"><span href="#/12_Part_02" id="pt2" title="Link target outside of Sample">ROMANIA</span></p>
<p class="toc1"><span href="#/13_Chapter_05" id="ch5" title="Link target outside of Sample">Sabres on the Sand</span></p>
<p class="toc1"><span href="#/14_Chapter_06" id="ch6" title="Link target outside of Sample">The Cook-runner</span></p>
<p class="toc2"><span href="#/15_Part_03" id="pt3" title="Link target outside of Sample">HUNGARY</span></p>
<p class="toc1"><span href="#/16_Chapter_07" id="ch7" title="Link target outside of Sample">Tell These Men to Go Away</span></p>
<p class="toc1"><span href="#/17_Chapter_08" id="ch8" title="Link target outside of Sample">The Picket Lines of Marton Hevessy</span></p>
<p class="toc1"><span href="#/18_Chapter_09" id="ch9" title="Link target outside of Sample">Roll Out the Barrel</span></p>
<p class="toc2"><span href="#/19_Part_04" id="pt4" title="Link target outside of Sample">SPAIN</span></p>
<p class="toc1"><span href="#/20_Chapter_10" id="ch10" title="Link target outside of Sample">Water of Iturrigorri</span></p>
<p class="toc1"><span href="#/21_Chapter_11" id="ch11" title="Link target outside of Sample">Three of Castile</span></p>
<p class="toc1"><span href="#/22_Chapter_12" id="ch12" title="Link target outside of Sample">The Pejemuller</span></p>
<p class="toc1"><span href="#/23_Chapter_13" id="ch13" title="Link target outside of Sample">Technique</span></p>
<p class="toc1"><span href="#/24_Chapter_14" id="ch14" title="Link target outside of Sample">Secret Police</span></p>
<p class="toc2"><span href="#/25_Part_05" id="pt5" title="Link target outside of Sample">ENGLAND</span></p>
<p class="toc1"><span href="#/26_Chapter_15" id="ch15" title="Link target outside of Sample">Twilight of a God</span></p>
<p class="toc1"><span href="#/27_Chapter_16" id="ch16" title="Link target outside of Sample">The Greeks Had No Word for It</span></p>
<p class="toc1"><span href="#/28_Chapter_17" id="ch17" title="Link target outside of Sample">Eggs as Ain’t</span></p>
<p class="toc1"><span href="#/29_Chapter_18" id="ch18" title="Link target outside of Sample">Abner of the Porch</span></p>
<p class="toc2"><span href="#/30_Part_06" id="pt6" title="Link target outside of Sample">FRANCE</span></p>
<p class="toc1"><span href="#/31_Chapter_19" id="ch19" title="Link target outside of Sample">The Sword and the Rake</span></p>
<p class="toc1"><span href="#/32_Chapter_20" id="ch20" title="Link target outside of Sample">Champion Antiochus</span></p>
<a id="page_6"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?3a539110